export default __webpack_public_path__ + "static/media/product2.dae15066.webp";